import type { IconData } from '@stacksjs/iconify-core'

export const alignLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64h480v32H16zm0 88h328v32H16zm0 88h480v32H16zm0 88h328v32H16zm0 88h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default alignLeft
